import { Statement } from "../types"

export function getAllStatementYears(statements: Statement[]): number[] {
  const years = new Set<number>()
  for (const statement of statements) {
    const year = new Date(statement.created_at).getFullYear()
    years.add(year)
  }
  return Array.from(years).sort((a, b) => b - a)
}
